import React from 'react';
import SEOHead from '../components/SEOHead';
import Hero from '../components/Hero';
import About from '../components/About';
import Courses from '../components/Courses';
import Team from '../components/Team';
import Features from '../components/Features';
import ClientTestimonials from '../components/ClientTestimonials';
import ContactUs from '../components/ContactUs';

function Home() {
  return (
    <>
      <SEOHead pageKey="home" />
      <Hero />
      <About />
      <Courses />
      <Team />
      <Features />
      <ClientTestimonials />
      <ContactUs />
    </>
  );
}

export default Home;
